import React, {useRef, useState} from 'react'
import firebase from '../../config/fbConfig.js'
import MainPanel from './components/mainPanel';
import Statistics from './admin/statistics';
import EditMenu from './admin/editMenu';
import {Helmet} from "react-helmet";

const auth = firebase.auth();

function PanelAdmin({user, setUser, restaurantList, DeOptimizeCart, DeOptimizeObject, getNameService, getNameState, getDateFormat, getStyleState}) {
    const [page, setPage] = useState(0)
    const menuNav = useRef()

    let signOut = () => {
        auth.signOut().then(() => {
			setUser(false)
		});
    }
    let changePage = (value) => {
        setPage(value);
    }

    let makeMain = (value) => {
        setPage(value)
        setTimeout(() => {
            if (window.location.href.includes('/en')) {
                document.getElementById('mainPanel').firstChild.innerHTML = 'Main Panel';
            } else {
                document.getElementById('mainPanel').firstChild.innerHTML = 'פאנל ראשי';
            }
            document.getElementById('tableWrapper').style.display = 'block';
            document.getElementById('archiveWrapper').style.display = 'none';
        }, 0);
    }
    
    let makeArchive = (value) => {
        setPage(value)
        setTimeout(() => {
            if (window.location.href.includes('/en')) {
                document.getElementById('mainPanel').firstChild.innerHTML = 'Archive & Search';
            } else {
                document.getElementById('mainPanel').firstChild.innerHTML = 'ארכיון & חיפוש';
            }          
            document.getElementById('tableWrapper').style.display = 'none';
            document.getElementById('archiveWrapper').style.display = 'block';      
        }, 0);
    }
    
	let openCloseMenu = () => {
		if (menuNav.current.checked) {
			document.getElementById('panelNav').children[1].style.top = (document.getElementById('panelNav').children[1].getBoundingClientRect().top+220) * -1 + 'px';
		} else {
			document.getElementById('panelNav').children[1].style.top = '-220px';
		}
    }
    function makeNavGoUp() {
        document.getElementById('panelNav').children[1].style.top = '-220px';
        menuNav.current.checked = false;
    }
    
if (window.location.href.includes('/en')) {
    return (
        <div>
            <Helmet>
                    <title>Admin Panel | Itay's Restaurant</title>
                    <meta 
                    name="description" 
                    content="Dashboard for Admins ! Itay's Restaurant (© Itay Shiff)" />
            </Helmet>

            <div id="panelNav">
                    <span>{user.email}</span>
                    <ul>
                        <li onClick={signOut}>Log-out</li>
                        <li data-id="0" onClick={(e) => { makeMain(e.target.dataset.id); makeNavGoUp(); } }>Main</li>
                        <li data-id="0" onClick={(e) => { makeArchive(e.target.dataset.id); makeNavGoUp(); } }>Archive</li>
                        <li data-id="1" onClick={(e) => { changePage(e.target.dataset.id); makeNavGoUp(); } }>Statistics</li>
                        <li data-id="2" onClick={(e) => { changePage(e.target.dataset.id); makeNavGoUp(); } }>Edit Menu</li>
                    </ul>
                <input type="checkbox" id="toggle-menu" onClick={openCloseMenu} ref={menuNav}/>
                    <label htmlFor="toggle-menu">
                    <span className="menu-icon"></span>
                </label>
            </div>
            

            {page==0 && <MainPanel restaurantList={restaurantList} DeOptimizeCart={DeOptimizeCart} DeOptimizeObject={DeOptimizeObject} getNameService={getNameService} getNameState={getNameState} getStyleState={getStyleState} getDateFormat={getDateFormat}/>}
            {/*page===1 && <ArchivePanel/>*/}
            {page==1 && <Statistics restaurantList={restaurantList}/>}
            {page==2 && <EditMenu/>}
        </div>
    )
}

// Else render it in Hebrew
    return (
        <div>
            <Helmet>
                    <title>פאנל מנהלי | המסעדה של איתי</title>
                    <meta 
                    name="description" 
                    content="פאנל למנהלים ! המסעדה של איתי שיף ©" />
            </Helmet>

            <div id="panelNav">
                    <span>{user.email}</span>
                    <ul>
                        <li onClick={signOut}>התנתק</li>
                        <li data-id="0" onClick={(e) => { makeMain(e.target.dataset.id); makeNavGoUp(); } }>ראשי</li>
                        <li data-id="0" onClick={(e) => { makeArchive(e.target.dataset.id); makeNavGoUp(); } }>ארכיון</li>
                        <li data-id="1" onClick={(e) => { changePage(e.target.dataset.id); makeNavGoUp(); } }>סטטיסטיקות</li>
                        <li data-id="2" onClick={(e) => { changePage(e.target.dataset.id); makeNavGoUp(); } }>עריכת תפריט</li>
                    </ul>
                <input type="checkbox" id="toggle-menu" onClick={openCloseMenu} ref={menuNav}/>
                    <label htmlFor="toggle-menu">
                    <span className="menu-icon"></span>
                </label>
            </div>
            

            {page==0 && <MainPanel restaurantList={restaurantList} DeOptimizeCart={DeOptimizeCart} DeOptimizeObject={DeOptimizeObject} getNameState={getNameState} getNameService={getNameService} getStyleState={getStyleState} getDateFormat={getDateFormat}/>}
            {/*page===1 && <ArchivePanel/>*/}
            {page==1 && <Statistics restaurantList={restaurantList}/>}
            {page==2 && <EditMenu/>}
        </div>
    )
}

export default PanelAdmin
